import { traineeList, traineeLetter} from "constants/trainee";

const initialState = {
  traineeList: {},
};

const trainees = (state = initialState, action) => {
  switch (action.type) {
    case traineeList:
      return { ...state, traineeList: action.payload };

    case traineeLetter:
      return { ...state, traineeLetter: action.payload };

    default:
      return state;
  }
};

export default trainees;
